import {
  CreateDialogButton,
  CreateDialogButtonProps,
} from '@/components/refinedev/dialogs/create-dialog-button';
import TaskForm from '../task-form';
import {BaseKey} from '@refinedev/core';

export const CreateTaskDialogButton = ({
  onSuccess,
  project_id,
  parent_task_id,
  canParams,
}: Pick<CreateDialogButtonProps, 'onSuccess' | 'canParams'> & {
  project_id: BaseKey;
  parent_task_id?: BaseKey;
}) => {
  return (
    <CreateDialogButton
      resource={'tasks'}
      title="Tạo công việc"
      canParams={canParams}
      transformBeforeSave={data => ({
        ...TaskForm.transformBeforeSave(data),
        project_id,
        parent_id: parent_task_id,
      })}
      formProps={{
        defaultValues: {...TaskForm.defaultValues, project_id, parent_id: parent_task_id},
      }}
      onSuccess={onSuccess}>
      <div className="flex flex-col">
        <TaskForm.GeneralInfo />
      </div>
    </CreateDialogButton>
  );
};
